// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listing-action-menu-popper {
  z-index: 1400;
}

.listing-action-menu,
.app-listing-action-menu .MuiPaper-root {
  box-sizing: border-box;
  width: 240px;
  max-width: calc(100vw - 16px);
  max-height: calc(100vh - 16px);
  padding: 4px;
  overflow-y: auto;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 10px;
  background: var(--surface-elevated, #ffffff);
  color: var(--text-primary, #142624);
  box-shadow: var(
    --elevation-medium,
    0 1px 2px rgba(14, 26, 32, 0.04),
    0 6px 16px -4px rgba(14, 26, 32, 0.1)
  );
  font-family: var(--font-family-primary, "Lexend", sans-serif);
}

.listing-action-menu {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.app-listing-action-menu .MuiMenu-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0;
}

.app-listing-action-menu .MuiMenuItem-root > * {
  width: 100%;
}

.app-listing-action-menu .MuiMenuItem-root a {
  display: block;
  width: 100%;
  color: inherit;
  text-decoration: none;
}

.app-listing-action-menu .credit-note-menu-item {
  box-sizing: border-box;
  width: 100%;
  height: 36px;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: none;
  white-space: nowrap;
}

.listing-action-menu > :is(a, button, span),
.app-listing-action-menu .MuiMenuItem-root {
  box-sizing: border-box;
  width: 100%;
  min-height: 36px;
  height: 36px;
  margin: 0;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: var(--text-primary, #142624);
  font: var(--font-weight-regular, 400) 14px / normal
    var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0;
  text-align: left;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}

.listing-action-menu > :is(a, button, span) > svg,
.listing-action-menu > :is(a, button, span) > .quotation-menu-icon,
.app-listing-action-menu .MuiMenuItem-root svg,
.app-listing-action-menu .credit-note-menu-item > svg {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  color: currentColor;
}

.listing-action-menu > :is(a, button):hover,
.listing-action-menu > :is(a, button):focus-visible,
.app-listing-action-menu .MuiMenuItem-root:hover,
.app-listing-action-menu .MuiMenuItem-root.Mui-focusVisible {
  background: var(--surface-secondary, #f4f7f7);
}

.listing-action-menu > :is(a, button):focus-visible {
  outline: 2px solid var(--focus-ring, #0f766e);
  outline-offset: -2px;
}

.listing-action-menu > :is(button, span):disabled,
.listing-action-menu > .disabled,
.listing-action-menu > [aria-disabled="true"],
.app-listing-action-menu .MuiMenuItem-root.Mui-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.listing-action-menu > .danger,
.listing-action-menu > .delete,
.listing-action-menu > .quotation-action-delete,
.listing-action-menu > .quotation-menu-item-delete,
.app-listing-action-menu .danger,
.app-listing-action-menu .credit-note-menu-delete {
  color: var(--danger-text, #a3301f);
}

.listing-action-menu
  > :is(.danger, .delete, .quotation-action-delete, .quotation-menu-item-delete):hover,
.listing-action-menu
  > :is(.danger, .delete, .quotation-action-delete, .quotation-menu-item-delete):focus-visible,
.app-listing-action-menu .credit-note-menu-delete:hover {
  background: var(--danger-soft, #fef2f1);
}

.listing-action-trigger.listing-action-trigger {
  box-sizing: border-box;
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}

.listing-action-trigger.listing-action-trigger:hover,
.listing-action-trigger.listing-action-trigger[aria-expanded="true"] {
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
}

.listing-action-trigger.listing-action-trigger:focus-visible {
  outline: 2px solid var(--focus-ring, #0f766e);
  outline-offset: 1px;
}

.listing-action-trigger.listing-action-trigger > svg {
  width: 16px;
  height: 16px;
}

@media (prefers-reduced-motion: reduce) {
  .listing-action-trigger.listing-action-trigger {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ListingActionMenu/listingActionMenu.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,gDAAgD;EAChD,mBAAmB;EACnB,4CAA4C;EAC5C,mCAAmC;EACnC;;;;GAIC;EACD,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC;oDACkD;EAClD,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;EAIE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;;;;EAIE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;;;EAME,kCAAkC;AACpC;;AAEA;;;;;EAKE,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;;EAEE,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".listing-action-menu-popper {\n  z-index: 1400;\n}\n\n.listing-action-menu,\n.app-listing-action-menu .MuiPaper-root {\n  box-sizing: border-box;\n  width: 240px;\n  max-width: calc(100vw - 16px);\n  max-height: calc(100vh - 16px);\n  padding: 4px;\n  overflow-y: auto;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  background: var(--surface-elevated, #ffffff);\n  color: var(--text-primary, #142624);\n  box-shadow: var(\n    --elevation-medium,\n    0 1px 2px rgba(14, 26, 32, 0.04),\n    0 6px 16px -4px rgba(14, 26, 32, 0.1)\n  );\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n}\n\n.listing-action-menu {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.app-listing-action-menu .MuiMenu-list {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 0;\n}\n\n.app-listing-action-menu .MuiMenuItem-root > * {\n  width: 100%;\n}\n\n.app-listing-action-menu .MuiMenuItem-root a {\n  display: block;\n  width: 100%;\n  color: inherit;\n  text-decoration: none;\n}\n\n.app-listing-action-menu .credit-note-menu-item {\n  box-sizing: border-box;\n  width: 100%;\n  height: 36px;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: none;\n  white-space: nowrap;\n}\n\n.listing-action-menu > :is(a, button, span),\n.app-listing-action-menu .MuiMenuItem-root {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 36px;\n  height: 36px;\n  margin: 0;\n  padding: 0 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--text-primary, #142624);\n  font: var(--font-weight-regular, 400) 14px / normal\n    var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0;\n  text-align: left;\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.listing-action-menu > :is(a, button, span) > svg,\n.listing-action-menu > :is(a, button, span) > .quotation-menu-icon,\n.app-listing-action-menu .MuiMenuItem-root svg,\n.app-listing-action-menu .credit-note-menu-item > svg {\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n  color: currentColor;\n}\n\n.listing-action-menu > :is(a, button):hover,\n.listing-action-menu > :is(a, button):focus-visible,\n.app-listing-action-menu .MuiMenuItem-root:hover,\n.app-listing-action-menu .MuiMenuItem-root.Mui-focusVisible {\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.listing-action-menu > :is(a, button):focus-visible {\n  outline: 2px solid var(--focus-ring, #0f766e);\n  outline-offset: -2px;\n}\n\n.listing-action-menu > :is(button, span):disabled,\n.listing-action-menu > .disabled,\n.listing-action-menu > [aria-disabled=\"true\"],\n.app-listing-action-menu .MuiMenuItem-root.Mui-disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.listing-action-menu > .danger,\n.listing-action-menu > .delete,\n.listing-action-menu > .quotation-action-delete,\n.listing-action-menu > .quotation-menu-item-delete,\n.app-listing-action-menu .danger,\n.app-listing-action-menu .credit-note-menu-delete {\n  color: var(--danger-text, #a3301f);\n}\n\n.listing-action-menu\n  > :is(.danger, .delete, .quotation-action-delete, .quotation-menu-item-delete):hover,\n.listing-action-menu\n  > :is(.danger, .delete, .quotation-action-delete, .quotation-menu-item-delete):focus-visible,\n.app-listing-action-menu .credit-note-menu-delete:hover {\n  background: var(--danger-soft, #fef2f1);\n}\n\n.listing-action-trigger.listing-action-trigger {\n  box-sizing: border-box;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n\n.listing-action-trigger.listing-action-trigger:hover,\n.listing-action-trigger.listing-action-trigger[aria-expanded=\"true\"] {\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n}\n\n.listing-action-trigger.listing-action-trigger:focus-visible {\n  outline: 2px solid var(--focus-ring, #0f766e);\n  outline-offset: 1px;\n}\n\n.listing-action-trigger.listing-action-trigger > svg {\n  width: 16px;\n  height: 16px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .listing-action-trigger.listing-action-trigger {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
